import { CommandType } from "~app/common/services/cqs/CommandType";
import { IVKAtgardKedjaKoppling } from "../../models/Atgardskedjor/atgardskedjor-models";
import { AtgardKedjaBaseCommand } from "./AtgardKedjaBaseCommand";

export class UpdateAtgardKedjaCommand extends AtgardKedjaBaseCommand {
    static readonly $type = "UpdateAtgardKedjaCommand";

    constructor(kedjaRowVersion: string, kontraktGuid: string, kedjaGuid: string, atgardKedjaKopplingar: IVKAtgardKedjaKoppling[]) {
        super(kedjaRowVersion, kontraktGuid, kedjaGuid, atgardKedjaKopplingar, UpdateAtgardKedjaCommand.$type, CommandType.Replace);
    }
}
